import { render, staticRenderFns } from "./PropertySection.vue?vue&type=template&id=39ca845d&scoped=true"
import script from "./PropertySection.vue?vue&type=script&lang=js"
export * from "./PropertySection.vue?vue&type=script&lang=js"
import style0 from "./PropertySection.vue?vue&type=style&index=0&id=39ca845d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca845d",
  null
  
)

export default component.exports